<template>
  <label class="checkbox" @click.prevent="toggle" :class="[{'on': isChecked}, {'is-disabled': disabled}]">
    <input type="checkbox"
    :name="name"
    ref="checkbox"
    :checked="isChecked"
    :disabled="disabled"
    v-model="realVal"
    :value="realVal"
    >
    <i class="icon-hook"></i>
    <span><slot></slot></span>
  </label>
</template>
<script>
  export default {
  	name: "uCheckbox",
    props: {
      name: String,
      label: String,
      disabled: Boolean,
      checked: Boolean,
      value: {},
      val: [String, Number, Boolean , Object],
      onChange: {
        type: Function,
        default() {},
      },
    },

    data() {
      return {
        isChecked: this.checked,
        realVal: null,
      };
    },

    watch: {
      realVal(val) {
        this.onChange(val);
      },
      checked(val) {
        this.handleChecked(val);
      },
    },

    methods: {
      toggle() {
        this.isChecked = !this.isChecked;

        if (this.val && !this.isChecked) {
          this.realVal = '';
          this.$emit('input', this.realVal);
        } else if (this.val && this.isChecked) {
          this.realVal = this.val;
          this.$emit('input', this.realVal);
        } else if (!this.val && this.isChecked) {
          this.realVal = true;
          this.$emit('input', this.realVal);
        } else {
          this.realVal = false;
          this.$emit('input', this.realVal);
        }
        this.$parent.isCheckboxGroup && this.$parent.updateValue();

      },
      handleChecked(isChecked) {
        this.isChecked = isChecked;
      },
    },

    mounted() {
      if (this.isChecked && !this.value) {
        this.$emit('input', this.$refs.checkbox.value);

      }
      if (this.value === this.val) {
        this.isChecked = true;
      }
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/uCheckbox/uCheckbox.vue